var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PROXY_MODE_TYPE, PROXY_MODE_TYPE_LABEL } from "@/presentation/pages/proxies/proxies-types";
export class RemoteLearningModeHandler {
    constructor() {
        this.learningModeOptions = [
            {
                label: PROXY_MODE_TYPE_LABEL.DEFAULT_ALLOW_BLACKLIST,
                value: PROXY_MODE_TYPE.DEFAULT_ALLOW_BLACKLIST
            },
            {
                label: PROXY_MODE_TYPE_LABEL.DEFAULT_BLOCK_PREVENTATIVE,
                value: PROXY_MODE_TYPE.DEFAULT_BLOCK_PREVENTATIVE
            },
        ];
        this.getFormattedSuperSelectOptions = (entities) => {
            return this.learningModeOptions;
        };
    }
    listEntity() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                resolve(this.learningModeOptions);
            });
        });
    }
}
